import { render } from "./WildBookFallCoordinates.vue?vue&type=template&id=6faf17b6&scoped=true&ts=true"
import script from "./WildBookFallCoordinates.vue?vue&type=script&lang=ts"
export * from "./WildBookFallCoordinates.vue?vue&type=script&lang=ts"

import "./WildBookFallCoordinates.vue?vue&type=style&index=0&id=6faf17b6&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\mobileApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6faf17b6"]])

export default __exports__